import { reportComoDataTypes } from './types';
import moment from "moment";

const { GET_REPORT_COMO_DATA, SET_REPORT_COMO_DATA_FILTERS, RESTORE_INITIAL } = reportComoDataTypes;

const initialState = {
  ReportComoData: [],
  date: moment(new Date()).format('YYYY'),
  station: null,
};

export const reportComoDataReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_REPORT_COMO_DATA:
      return { ...state, ReportComoData: payload };
    case SET_REPORT_COMO_DATA_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case RESTORE_INITIAL:
      return initialState;
    default:
      return state;
  }
};
